/** iter282 — Récupère une photo de la bibliothèque en data URL (pour la rogner avant lecture). */
import api from "@/lib/api";

export async function photoDataUrl(pid) {
  const { data } = await api.get(`/photos/${pid}/file`, { responseType: "blob" });
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = reject;
    reader.onload = () => resolve(reader.result);
    reader.readAsDataURL(data);
  });
}
